// Generated with util/create-component.js
import Grid from "./Grid";
export default Grid;
  